import React from 'react'
import {FeatureContainer,FeatureBtn} from './FeatureItems'

const Feature = () => {
    return (
        <FeatureContainer>
            <h1>Burger of the Day</h1>
            <p>Pepper Don't Preach Burger comes with Roasted Peppers</p>
            <FeatureBtn>Order Now</FeatureBtn>
        </FeatureContainer>
    )
}

export default Feature
